<template>
  <div class="page-head">
    <img :src="imgUrl" alt="" />
    <div class="head-slot">
      <slot />
    </div>

    <slot name="head-slot" />
  </div>
</template>

<script>
import API from "@/api";
import { getImageUrl } from "@/utils/tool";
export default {
  name: "page-head",
  props: {
    bannerType: {
      type: String,
      default: "bgimg",
    },
  },
  data() {
    return {
      pic: null,
      img: {
        bgimg: require("@/assets/images/about-img/bg-img.png"),
        aboutus: require("@/assets/images/about-img/banner-aboutus.png"),
        yqzs: require("@/assets/images/about-img/banner-yqzs.png"),
        talent: require("@/assets/images/about-img/banner-talent.png"),
        visit: require("@/assets/images/about-img/banner-visit.png"),
        yqzx: require("@/assets/images/about-img/banner-yqzx.png"),
        cfzs: require("@/assets/images/about-img/bg-img.png"),
      },
    };
  },
  // 计算属性
  computed: {
    imgUrl() {
      if (this.pic) {
        return getImageUrl(this.pic);
      } else {
        console.log("this.bannerType", this.bannerType);
        return this.img[this.bannerType] || this.img["bgimg"];
      }
    },
  },
  mounted() {
    const routePicTypeMap = {
      about: "aboutUs",
      information: "parkZx",
      "talents-bringIn": "recruit",
      "product-service": "investment",
      "visitor-make": "visitor",
      "user-login": "userLogin",
      "park-details": "investment",
      "job-details": "recruit",
    };

    let route = this.routeName;
    let picType = routePicTypeMap[route] || null;
    if (picType) this.getPic(picType);
  },
  methods: {
    getPic(picType) {
      let params = {
        belong: 2,
        picType,
      };
      API.getPic(params).then((res) => {
        this.pic = res?.pics;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-head {
  @include inheritWH(percent, 500px);
  padding: 131px 0 0 226px;
  @include absolute-positioning;

  & > img {
    @include absolute-positioning(absolute);
    z-index: 1;
  }

  .head-slot {
    position: absolute;
    z-index: 2;
  }
}
</style>
